// 导入Vue的核心方法，用于创建应用实例
import { createApp } from 'vue'
// 导入根组件App.vue
import App from './App.vue'
// 导入路由配置
import router from './router'
// 导入ViewUIPlus组件库的样式文件
import 'view-ui-plus/dist/styles/viewuiplus.css'
// 导入ViewUIPlus UI组件库
import ViewUIPlus from 'view-ui-plus'
// 全局引入Chart.js图表库
import 'chart.js'
// 导入全局响应式样式（适配手机和平板）
import '@/assets/responsive.css'

// ============ 初始化Vue应用 ============
function initVueApp() {
    console.log('🚀 初始化Vue应用...');
    
    const app = createApp(App);
    
    // 使用ViewUIPlus组件库
    app.use(ViewUIPlus);
    
    // 使用路由
    app.use(router);
    
    // 挂载应用到#app元素
    app.mount('#app');
    
    console.log('✅ Vue应用初始化完成');
}

// ============ 启动应用 ============
(function main() {
    console.log('%c═══════════════════════════════════════', 'color: #667eea; font-weight: bold;');
    console.log('%c 应用启动', 'color: #667eea; font-size: 16px; font-weight: bold;');
    console.log('%c═══════════════════════════════════════', 'color: #667eea; font-weight: bold;');
    
    // 直接初始化Vue应用
    // 站点状态检查已移至 TiktokQuery.vue 的 mounted 钩子中执行
    initVueApp();
    
    console.log('%c═══════════════════════════════════════', 'color: #67c23a; font-weight: bold;');
    console.log('%c✅ 应用启动完成', 'color: #67c23a; font-size: 16px; font-weight: bold;');
    console.log('%c═══════════════════════════════════════', 'color: #67c23a; font-weight: bold;');
})();
